import { useGet } from '../../api/queries/useGet';

type BlockedPagesResponse = Record<number, boolean>;

export const useGetBlockedPagesRequest = () => {
    const { data: blockedPages, error, loading } = useGet<BlockedPagesResponse>({ url: '/license/getBlockedPages' });

    return { blockedPages, error, loading };
};
